
import * as defaultImport from "hoist-non-react-statics";
export * from "hoist-non-react-statics";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
